<template>
  <div class="works">
    <div class="upload_btn" v-show="isDetailPage" @click="hanndleGoPublish">
      <i class="el-icon-plus"></i>发表作品
    </div>
    <div class="search_bar">
      <el-form
        :model="searchForm"
        ref="searchForm"
        class="search_form"
        :inline="true"
        size="small"
      >
        <el-form-item label="" prop="query">
          <el-input
            v-model="searchForm.query"
            placeholder="请输入关键词"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="userId">
          <el-select
            v-model="searchForm.userId"
            filterable
            placeholder="请选择或输入学生姓名"
          >
            <el-option
              v-for="item in studentList"
              :key="item.userId"
              :label="item.name + ' ' + item.sno"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="classChapterId" v-show="!isDetailPage">
          <el-cascader
            v-model="searchForm.classChapterId"
            :options="chapters"
            @change="getTaskList"
            :props="{
              label: 'title',
              value: 'classChapterId',
              emitPath: false,
            }"
            :show-all-levels="false"
            placeholder="请选择章节"
            clearable
          ></el-cascader>
          <!-- <el-select
            v-model="searchForm.classChapterId"
            placeholder="请选择章节"
            clearable
            @change="getTaskList"
          >
            <el-option
              v-for="item in chapters"
              :key="item.classChapterId"
              :label="item.title"
              :value="item.classChapterId"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="" prop="taskId">
          <el-select
            v-model="searchForm.taskId"
            placeholder="请选择实战"
            clearable
            :no-data-text="
              searchForm.classChapterId ? '无数据' : '请先选择章节'
            "
          >
            <el-option
              v-for="item in taskList"
              :key="item.taskId"
              :label="item.title"
              :value="item.taskId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="marked">
          <el-radio-group
            v-model="searchForm.marked"
            size="small"
            @change="getList"
          >
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button :label="true">已评分</el-radio-button>
            <el-radio-button :label="false">未评分</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="btns" style="float: right; margin-right: 0">
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button @click="resetForm('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="work_box" :class="{ 'detail-page': isDetailPage }">
      <template v-if="total > 0">
        <div class="one_work" v-for="item in workList" :key="item.id">
          <el-image
            class="avatar"
            :src="item.worksType == 'TEAM' ? item.teamIcon : item.avatar"
            fit="cover"
          ></el-image>
          <div class="right_content">
            <div class="work">
              <p class="name">
                {{
                  item.worksType == "TEAM"
                    ? item.teamName
                    : item.nickName + " " + item.sno
                }}
                <!-- <i
                  class="el-icon-delete"
                  v-show="myId == item.userId"
                  @click="handleDelWorks(item.worksId)"
                ></i> -->
                <el-button
                  type="text"
                  class="redo"
                  v-show="item.status == 'REDO'"
                  @click="
                    handleRo(
                      item.worksId,
                      item.classChapterId,
                      item.chapterName
                    )
                  "
                  >重做</el-button
                >
                <el-tag size="mini" effect="dark" style="margin-left: 20px">{{
                  item.worksType == "TEAM" ? "团队作品" : "个人作品"
                }}</el-tag>
                <el-tag
                  size="mini"
                  effect="dark"
                  style="margin-left: 10px"
                  v-show="
                    item.worksType == 'PERSONAL' &&
                    item.teamId == myTeamId &&
                    item.userId != myId
                  "
                  >我的队友</el-tag
                >
                <el-tag
                  size="mini"
                  effect="dark"
                  style="margin-left: 10px"
                  v-show="item.worksType == 'TEAM' && item.teamId == myTeamId"
                  >我的团队</el-tag
                >
                <el-tag
                  v-show="item.great"
                  size="mini"
                  effect="dark"
                  type="danger"
                  style="margin-left: 10px"
                  >优秀</el-tag
                >
                <el-tag
                  v-show="item.typical"
                  size="mini"
                  effect="dark"
                  type="warning"
                  style="margin-left: 10px"
                  >典型</el-tag
                >
                <el-tag
                  size="mini"
                  effect="dark"
                  type="danger"
                  style="margin-left: 10px"
                  v-show="item.status == 'REDO'"
                  >被打回</el-tag
                >
              </p>
              <p class="text_content" v-if="item.info">
                {{ item.info }}
              </p>
              <div class="media_content">
                <div
                  class="one_media"
                  v-for="t in item.showFiles"
                  :key="t.worksFileId"
                >
                  <video
                    v-if="t.type == 'mp4'"
                    :src="t.url"
                    controls="controls"
                  ></video>

                  <el-image
                    style="width: 100%; height: 100%"
                    v-else
                    :src="t.url"
                    :preview-src-list="getImgList(t)"
                  >
                  </el-image>
                </div>
                <div
                  class="other-type"
                  v-for="t in item.otherFiles"
                  :key="t.worksFileId"
                >
                  <i class="el-icon-document"></i>
                  <a :href="t.url" target="_blank" title="点击下载" download>{{
                    t.fileName
                  }}</a>
                </div>
              </div>
              <div class="bottom_row clearfix">
                <span class="chapter_name"
                  >{{ item.chapterName }} —
                  {{ item.taskId == 0 ? "默认实战" : item.taskTitle }}</span
                >
                <span class="time">{{
                  formatDate(item.createTime, "YYYY-MM-DD HH:mm:ss")
                }}</span>

                <div class="right_btns">
                  <span
                    class="score-text avg"
                    v-if="item.studentScoreList.length > 0"
                    @click="showAvgList(item.studentScoreList)"
                    >{{
                      item.worksType == "TEAM"
                        ? "组间评分均分"
                        : "组内互评均分"
                    }}：{{ getAvg(item.studentScoreList) }}</span
                  >
                  <span
                    v-if="item.worksType == 'TEAM' && myTeamId == item.teamId"
                    @click="handleScoreTeam(item.teamId, item.worksId)"
                    class="team-score"
                    >组内评分</span
                  >
                  <span class="score-text" v-if="item.teacherScore"
                    >教师评分：{{ item.teacherScore }}</span
                  >
                  <span class="score-text" v-if="item.score"
                    >我的评分：{{ item.score }}</span
                  >
                  <template
                    v-if="
                      (item.worksType == 'PERSONAL' &&
                        myTeamId == item.teamId) ||
                      (item.worksType == 'TEAM' && isCaptain)
                    "
                  >
                    <el-popover
                      v-if="!item.score"
                      placement="left"
                      title="评分"
                      width="160"
                      trigger="click"
                      :ref="'popover-' + item.worksId"
                      :popper-options="{ removeOnDestroy: true }"
                    >
                      <el-input-number
                        v-model="score"
                        :min="0"
                        :max="100"
                        size="small"
                      ></el-input-number>
                      <div style="text-align: right; margin-top: 10px">
                        <el-button
                          size="mini"
                          type="text"
                          @click="handleCancel(item.worksId)"
                          >取消</el-button
                        >
                        <el-button
                          type="primary"
                          size="mini"
                          @click="changeScore(item.worksId, score)"
                          >确定</el-button
                        >
                      </div>
                      <img
                        slot="reference"
                        src="@/assets/images/icons/icon_score.png"
                      />
                    </el-popover>
                  </template>
                  <!-- <img
                    v-else-if="item.worksType == 'TEAM'"
                    src="@/assets/images/icons/icon_score.png"
                    alt=""
                    @click="handleScoreTeam(item.teamId, item.worksId)"
                  /> -->
                  <img
                    src="@/assets/images/icons/icon_comment.png"
                    alt=""
                    @click="
                      myComment = '';
                      currentComment = item.worksId;
                    "
                  />
                  <!-- <img
                    :src="
                      item.fabulous
                        ? require('@/assets/images/icons/icon_like_full.png')
                        : require('@/assets/images/icons/icon_like.png')
                    "
                    alt=""
                    @click="handleLike(item)"
                  /> -->
                </div>
              </div>
            </div>
            <div
              class="comments"
              v-if="item.commentList && item.commentList.length > 0"
            >
              <div
                class="one_comment"
                v-for="comment in item.commentList"
                :key="comment.id"
              >
                <p class="c_row">
                  <span class="c_name">{{ comment.nickName }}：</span>
                  <span class="c_content">{{ comment.info }}</span>
                </p>
                <i
                  class="el-icon-delete"
                  v-show="myId == comment.userId"
                  @click="handleDelComment(comment.commentId)"
                ></i>
              </div>
            </div>

            <div class="reply_edit" v-if="currentComment == item.worksId">
              <el-input
                v-model="myComment"
                type="textarea"
                resize="none"
                :autosize="{ minRows: 3 }"
                :placeholder="'回复 ' + item.nickName + ':'"
              ></el-input>
              <div class="btn_row">
                <el-button
                  size="small"
                  round
                  @click="
                    currentComment = null;
                    myComment = '';
                  "
                  style="width: 80px"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  round
                  @click="handlePublish"
                  style="width: 80px"
                  >发表</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <el-empty description="暂无作品" v-else></el-empty>
    </div>

    <div class="foot_page">
      <el-pagination
        background
        layout="prev, pager, next, sizes, jumper"
        :page-size="searchForm.limit"
        :current-page.sync="searchForm.page"
        :total="total"
        :page-sizes="[10, 20, 30, 40]"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>

    <!-- 组内互评 -->
    <el-dialog
      title="组内互评"
      :visible.sync="showTeamScore"
      class="teamscore-dialog"
      width="50%"
      center
    >
      <div class="left">
        <h3>我给组员的评分</h3>
        <div class="row" v-for="(item, idx) in myTeamScoreArr" :key="idx">
          <span class="name">{{ item.toNickName || item.toUsername }}</span>
          <el-input-number
            v-model="item.score"
            :min="0"
            :max="100"
            size="small"
            :disabled="haveScore"
          ></el-input-number>
        </div>
      </div>
      <div class="right">
        <h3>组员给我的评分</h3>
        <div class="row" v-for="(item, idx) in myScoreArr" :key="idx">
          <span class="name">{{ item.toNickName || item.toUsername }}</span>
          <el-input-number
            v-if="item.score && item.score != 0"
            v-model="item.score"
            :min="0"
            :max="100"
            size="small"
            disabled
          ></el-input-number>
          <span v-else style="display: inline-block; width: 40%">暂未评分</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamScore = false">取 消</el-button>
        <el-button
          style="margin-left: 50px"
          type="primary"
          @click="handleSubmitMyTeamScore"
          :disabled="haveScore"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="学生评分列表" :visible.sync="showAvg" center width="50%">
      <el-table class="avg-list" :data="avgList">
        <el-table-column
          prop="nickName"
          label="姓名"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="sno" label="学号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="score" label="评分" width="100" align="center">
        </el-table-column>
        <el-table-column prop="teamName" label="所属团队" align="center">
          <template slot-scope="scope">
            {{ scope.row.teamName || "无" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  worksList,
  delWorks,
  giveComment,
  delComment,
  giveGrade,
  myTeamScore,
  myScore,
  giveMyTeamGrade,
} from "@/api/works";
import { practiceList } from "@/api/practice";
import { myTeam } from "@/api/team";
import { studentList } from "@/api/class";
import { formatDate } from "@/utils/index";
export default {
  props: {
    chapterInfo: Object,
  },
  data() {
    return {
      formatDate,
      searchForm: {
        page: 1,
        limit: 10,
        classId: this.$route.query.id,
        userId: null,
        query: "",
        classChapterId: Number(this.$route.query.classChapterId) || null,
        taskId: null,
        marked: null,
      },
      total: 10,
      taskList: [],
      studentList: [],
      activeId: null,
      workList: [],
      score: 0,
      srcList: [],
      myComment: "",
      currentComment: null,
      isDetailPage: false,
      myTeamInfo: {},
      myTeamId: null,
      showTeamScore: false,
      myTeamScoreArr: [],
      myScoreArr: [],
      currentWorksId: null,
      haveScore: false,
      showAvg: false,
      avgList: [],
    };
  },
  created() {
    if (this.$route.query.marked)
      this.searchForm.marked = this.$route.query.marked;
    if (this.$route.path == "/courseDetail/works") {
      this.isDetailPage = true;
      this.getTaskList();
    }

    this.getStudents();
    this.getList();
    this.getMyTeam();
  },
  computed: {
    myId() {
      return this.$store.state.myInfo.userId;
    },
    chapters() {
      return this.$store.state.chapterList;
      // let arr = [];
      // let chapters = this.$store.state.chapterList;
      // chapters.forEach((item) => {
      //   if (item.children) {
      //     arr.push(item);
      //     arr = arr.concat(item.children);
      //   }
      // });
      // return arr;
    },
    update() {
      return this.$store.state.update;
    },
    isCaptain() {
      return this.myId == this.myTeamInfo.captainId;
    },
  },
  watch: {
    update(val) {
      if (val) {
        this.getList();
        this.$store.commit("SET_UPDATE", false);
      }
    },
  },
  methods: {
    // 作品列表
    getList() {
      if (this.$route.query.classChapterId)
        this.searchForm.classChapterId = this.$route.query.classChapterId;
      this.$loading.show();
      worksList(this.searchForm).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // console.log(res);
          res.data.records.forEach((item) => {
            item.showFiles = [];
            item.otherFiles = [];
            item.fileList.forEach((file) => {
              file.type = file.type ? file.type.toLowerCase() : "";
              if (
                file.type != "mp4" &&
                file.type != "png" &&
                file.type != "jpg" &&
                file.type != "jpeg" &&
                file.type != "gif"
              ) {
                item.otherFiles.push(file);
              } else {
                item.showFiles.push(file);
              }
            });
          });
          this.workList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 实战列表
    getTaskList() {
      practiceList({
        classId: this.$route.query.id,
        classChapterId: this.isDetailPage
          ? this.$route.query.classChapterId
          : this.searchForm.classChapterId,
      }).then((res) => {
        if (res.code == 0) {
          this.taskList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 班级学生
    getStudents() {
      studentList({
        classId: this.$route.query.id,
      }).then((res) => {
        if (res.code == 0) {
          this.studentList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getList();
    },
    getImgList(t) {
      let images = [];
      images.push(t.url);
      return images;
    },
    // 点赞
    // handleLike(item) {
    //   item.fabulous = !item.fabulous;
    // },
    // 翻页
    pageChange() {
      this.getList();
    },
    // 评分
    changeScore(worksId, score) {
      this.$confirm(`评分后不可更改,确定要评分吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          giveGrade({ worksId, score }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.handleCancel(worksId);
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleCancel(id) {
      this.$refs[`popover-${id}`][0].doClose();
    },
    // 发表评论
    handlePublish() {
      this.$loading.show();
      giveComment({ worksId: this.currentComment, info: this.myComment }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("发表成功");
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
      this.currentComment = null;
      this.myComment = "";
    },
    // 删除自己的评论
    handleDelComment(commentId) {
      this.$confirm("确定要删除这条评论吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delComment(commentId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 重做
    handleRo(worksId, classChapterId, chapterName) {
      this.$router.push({
        path: "/courseDetail/works/uploadWorks",
        query: {
          ...this.$route.query,
          worksId,
          classChapterId,
          chapterTitle: chapterName,
        },
      });
    },
    // 删除自己的作品
    handleDelWorks(worksId) {
      this.$confirm("确定要删除该作品吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delWorks(worksId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 我的团队
    getMyTeam() {
      myTeam({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.myTeamInfo = res.data;
            this.myTeamId = res.data.teamId;
          }
        } else {
          console.log(res.msg);
        }
      });
    },
    // 发表作品权限判断
    hanndleGoPublish() {
      if (this.chapterInfo.szType == "TEAM" && !this.isCaptain) {
        this.$message.warning("该章节为团队任务，只有队长能上传作品");
        return;
      }
      this.$router.push({
        path: "/courseDetail/works/uploadWorks",
        query: this.$route.query,
      });
    },
    handleScoreTeam(teamId, worksId) {
      if (!this.isCaptain && this.myTeamId != teamId) {
        this.$message.warning("只有队长才能对其他团队作品评分");
        return;
      }
      this.getMyTeamScore(worksId);
    },
    // 自己的组内评分
    getMyTeamScore(worksId) {
      myTeamScore(worksId).then((res) => {
        if (res.code == 0) {
          this.myTeamScoreArr = res.data;
          this.currentWorksId = worksId;
          this.showTeamScore = true;
          this.haveScore = !!res.data[0].userId;
        } else {
          console.log(res.msg);
        }
      });
      myScore(worksId).then((res) => {
        if (res.code == 0) {
          this.myScoreArr = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    handleSubmitMyTeamScore() {
      this.$confirm(`评分后不可更改,确定要评分吗？`, {
        type: "warning",
      })
        .then(() => {
          giveMyTeamGrade({
            worksId: this.currentWorksId,
            arr: this.myTeamScoreArr,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success("打分成功");
              this.showTeamScore = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    getAvg(arr) {
      let sum = arr.reduce(function (prev, curr) {
        return curr.score + prev;
      }, 0);
      return Number((sum / arr.length).toFixed(2));
    },
    showAvgList(arr) {
      this.showAvg = true;
      this.avgList = arr;
    },
  },
};
</script>

<style lang="less" scoped>
.works {
  margin-bottom: 50px;
  text-align: left;

  .upload_btn {
    margin-bottom: 20px;
    height: 36px;
    line-height: 36px;
    color: #1890ff;
    font-size: 18px;
    text-align: center;
    border: dashed 1px #1890ff;
    cursor: pointer;
    .el-icon-plus {
      margin-right: 5px;
    }
  }
  .search_form {
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 4px;
    background-color: #fff;

    .el-form-item {
      margin-bottom: 0;
      margin-right: 15px;
      &.no-margin {
        margin-right: 0;
      }
    }
    ::v-deep .el-input__inner {
      width: 190px;
    }
  }

  .work_box {
    padding: 30px;
    border-radius: 4px;
    background-color: #fff;
    &.detail-page {
      height: calc(100% - 76px - 70px - 55px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
    .one_work {
      margin-bottom: 18px;

      .avatar {
        margin-right: 20px;
        width: 64px;
        height: 64px;
        border-radius: 5px;
        vertical-align: top;
      }
    }
    .el-empty {
      padding: 80px 0;
    }
  }

  .right_content {
    display: inline-block;
    width: calc(100% - 64px - 20px);
    border-bottom: solid 1px #c8c8c8;
    .work {
      .name {
        font-size: 16px;
        color: #1890ff;

        .el-icon-delete {
          float: right;
          color: #f56c6c;
          font-size: 22px;
          cursor: pointer;
        }
        .redo {
          float: right;
          padding: 0;
          color: #f56c6c;
        }
      }

      .text_content {
        margin-top: 15px;
        font-size: 16px;
      }

      .media_content {
        margin-top: 15px;
        .one_media {
          display: inline-block;
          margin-right: 7px;
          width: 200px;
          height: 200px;
          border-radius: 5px;
          overflow: hidden;

          img,
          video {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
          }
        }
        .other-type {
          margin-top: 10px;
          font-size: 16px;
          a {
            margin-left: 5px;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .bottom_row {
        margin: 10px 0;

        .chapter_name,
        .time {
          color: #c8c8c8;
          font-size: 14px;

          &.chapter_name {
            margin-right: 20px;
          }
        }

        .right_btns {
          float: right;

          .score_box {
            position: relative;
            display: inline-block;
            .score_text {
              position: absolute;
              top: -25px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 16px;
              color: #409eff;
            }
            ::v-deep .score_slide {
              width: 200px;

              .el-slider__runway {
                margin: 0;
              }
            }
          }

          img {
            margin-left: 20px;
            width: 20px;
            cursor: pointer;
          }

          .team-score {
            margin-left: 10px;
            color: #c8c8c8;
            font-size: 14px;
            cursor: pointer;
          }

          .score-text {
            margin-left: 10px;
            font-size: 14px;
            color: #c8c8c8;
            &.avg {
              cursor: pointer;
            }
          }
        }
      }
    }

    .comments {
      margin-bottom: 15px;
      padding: 15px;
      background-color: #eee;
      border-radius: 10px;

      .one_comment {
        position: relative;
        margin-bottom: 5px;
        .c_row {
          width: 98%;
          .c_name {
            font-size: 16px;
            color: #1890ff;
          }

          .c_content {
            font-size: 16px;
          }
        }

        .el-icon-delete {
          position: absolute;
          right: 0;
          bottom: 0;
          color: #f56c6c;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }

    .reply_edit {
      padding-bottom: 10px;

      .btn_row {
        margin-top: 10px;
        text-align: right;
      }
      ::v-deep .el-textarea__inner {
        font-family: inherit;
      }
    }
  }

  ::v-deep .foot_page {
    margin-top: 20px;
    text-align: right;

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0d79ff;
    }

    .el-pagination__total {
      float: left;
    }
  }

  ::v-deep .comment_dialog {
    .el-textarea__inner {
      font-family: inherit;
    }
  }
  .teamscore-dialog {
    .left,
    .right {
      display: inline-block;
      width: 50%;
      text-align: center;
      vertical-align: top;
    }
    .row {
      margin: 15px 0;
      height: 32px;
      line-height: 32px;
      text-align: center;
      .name {
        display: inline-block;
        margin-right: 30px;
        width: 100px;
        text-align: right;
      }
    }
  }
  ::v-deep .avg-list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>